import React, { useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AdminBlogForm = () => {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [content, setContent] = useState(""); // Content for rich-text editor
  const [additionalImages, setAdditionalImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const accessToken = localStorage.getItem("authToken");

  // Function to generate a slug from the title
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric characters with hyphens
      .replace(/(^-|-$)+/g, ""); // Remove leading/trailing hyphens
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append("image", image);

    const response = await axios.post(
      "https://365luxuryhomes.com/api/blogs/upload-image",
      formData
    );
    return response.data.url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const mainImageUrl = await handleImageUpload(mainImage);

      const additionalImagesUrls = await Promise.all(
        additionalImages.map((image) => handleImageUpload(image))
      );

      const slug = generateSlug(title); // Generate slug from the title

      const blogData = {
        title,
        slug,
        date,
        mainImage: mainImageUrl,
        content,
        additionalImages: additionalImagesUrls,
      };

      await axios.post("https://365luxuryhomes.com/api/blogs", blogData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      alert("Blog posted successfully!");
      setTitle("");
      setDate("");
      setMainImage(null);
      setContent("");
      setAdditionalImages([]);
    } catch (error) {
      console.error("Error posting blog:", error);
      alert("Failed to post blog.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddImageField = () => {
    setAdditionalImages([...additionalImages, null]);
  };

  const handleImageChange = (index, file) => {
    const updatedImages = [...additionalImages];
    updatedImages[index] = file;
    setAdditionalImages(updatedImages);
  };

  const handleRemoveImageField = (index) => {
    const updatedImages = additionalImages.filter((_, i) => i !== index);
    setAdditionalImages(updatedImages);
  };

  return (
    <section className="py-20">
      <form
        className="container mx-auto p-6 max-w-3xl bg-white"
        onSubmit={handleSubmit}
      >
        <h1 className="text-2xl font-semibold mb-6 text-[#aca9a5]">
          Add New Blog
        </h1>

        <div className="mb-4">
          <label className="block text-[#aca9a5]">Title</label>
          <input
            type="text"
            className="border rounded w-full p-2 bg-transparent"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-[#aca9a5]">Publication Date</label>
          <input
            type="date"
            className="border rounded w-full p-2 bg-transparent"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-[#aca9a5]">Main Image</label>
          <input
            type="file"
            accept="image/*"
            className="border rounded w-full p-2 bg-transparent"
            onChange={(e) => setMainImage(e.target.files[0])}
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-[#aca9a5]">Content</label>
          <ReactQuill
            value={content}
            onChange={setContent}
            className="bg-transparent"
            style={{ height: "200px" }}
            theme="snow"
            placeholder="Write your blog content here..."
          />
        </div>

        <div className="mb-4 mt-12">
          <label className="block text-[#aca9a5]">Additional Images</label>
          {additionalImages.map((_, index) => (
            <div key={index} className="flex items-center mb-2">
              <input
                type="file"
                accept="image/*"
                className="border rounded w-full p-2 mr-2 bg-transparent"
                onChange={(e) => handleImageChange(index, e.target.files[0])}
              />
              <button
                type="button"
                onClick={() => handleRemoveImageField(index)}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddImageField}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 mt-2"
          >
            Add More Image
          </button>
        </div>

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          disabled={loading}
        >
          {loading ? "Posting..." : "Post Blog"}
        </button>
      </form>
    </section>
  );
};

export default AdminBlogForm;
